import {
  WorklistsReportDataRow,
  WorklistsReportPayloadEntry,
} from '@/app/components/Reporting/Collaboration/WorklistsReport/types';
import moment from 'moment';
import { getAllEmployees } from '@/old/utils/helper';

export const mapReportDataForGrid = (
  payload: WorklistsReportPayloadEntry[],
): WorklistsReportDataRow[] => {
  const payloadWithDataEntries = payload.filter(
    p => p.fDataEntriesEmpl.length > 0,
  );

  const allEmployees = getAllEmployees();

  return payloadWithDataEntries.reduce((acc, entry) => {
    const {
      fEmpId,
      fEmpFirstName,
      fEmpLastName,
      fEmpEmployeeNumber,
      fEmpUnit,
      fEmpUnitId,
      fEmpUnitNumber,
      fDataEntriesEmpl,
    } = entry;

    const employee = allEmployees[fEmpId];

    const worklistRows = fDataEntriesEmpl.map(
      (dataEntry): WorklistsReportDataRow => {
        const {
          fWorklistTemplateFk,
          fWorklistStatus,
          fWorklistDueDate,
          fWorklistStartDate,
        } = dataEntry;

        const getDateOrUndefined = (dateString: string | undefined): Date | undefined => {
          return !!dateString ? moment(dateString).toDate() : undefined;
        };

        return {
          empId: fEmpId,
          hasAccount: employee.fEmpHasAccount,
          position: employee.fEmpPosition,
          firstName: fEmpFirstName,
          lastName: fEmpLastName,
          employeeNumber: fEmpEmployeeNumber,
          unit: fEmpUnit,
          unitId: fEmpUnitId,
          unitNo: fEmpUnitNumber,
          worklistId: fWorklistTemplateFk,
          worklistName: '',
          worklistStatus: fWorklistStatus,
          startDate: getDateOrUndefined(fWorklistStartDate),
          dueDate: getDateOrUndefined(fWorklistDueDate),
        };
      },
    );
    return acc.concat(worklistRows);
  }, [] as WorklistsReportDataRow[]);
};
